import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { UPDATE_CONTACTS } from './types';

export const updateContacts = createTaskAction(UPDATE_CONTACTS);
